
export const xhrSearch = (what, where, distance, lat, lng, bbox, paymentMethod) => {
    return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();
        http.responseType = 'json';
        // const params = window.location.search.substr(1) +
        //     '&CRAFT_CSRF_TOKEN=' + csrf;
        const url = `/kvbm/search?what=${what}&where=${where}&distance=${distance}&lat=${lat}&lng=${lng}&bbox=${bbox}&payment-method=${paymentMethod}`;
        http.open('GET', encodeURI(url), true);
        http.onreadystatechange = () => {
            if (http.readyState === 4 && http.status === 200) {
                resolve(http);
            } else if (http.readyState === 4 && http.status !== 200) {
                reject(http);
            }
        }
        http.send();
    });
}
